import React from "react";
import DataCard from "./Card";
import data from "./data";
import styles from "./CircularCards.module.scss";

const CircularCards = () => {
  
  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["content"]}>
          <div className={styles["data-cards"]}>
            {data.map((card, index, label) => {
              return <DataCard index={index} key={card.id} {...label}{...card}></DataCard>;
            })}
          </div>
          </div>
        </div>
    </>
  );
};

export default CircularCards;
